export default "__VITE_ASSET__slD$vrm2__"